module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-02 (1).c19292d2.svg";